module.exports = __webpack_public_path__ + "img/enLangBtn.6473c4b3.png";